import { SelectInput } from 'react-admin';
import { SearchBar } from '@/components/global/list/searchBar';
import { ReferenceArrayFilter } from '@/components/global/filters/filters.jsx';
import { getRoleChoices, getClientRoleChoices, getServiceRoleChoices } from '@/components/users/roleChoices.js';

const adminSearchBar = translate => <SearchBar source='value' label={translate('common.search')} alwaysOn />;
const masterSearchBar = translate => <SearchBar source='value' label={translate('common.search')} alwaysOn />;

const roleFilter = (translate, isMobile) => (
    <SelectInput
        source='role'
        label={translate('resources.user.filters.role')}
        choices={getRoleChoices(translate)}
        emptyText={translate('common.all')}
        alwaysOn={isMobile}
    />
);
const clientMasterRoleFilter = (translate, isMobile) => (
    <SelectInput
        source='role'
        label={translate('resources.user.filters.role')}
        choices={getClientRoleChoices(translate)}
        emptyText={translate('common.all')}
        alwaysOn={isMobile}
    />
);
const serviceMasterRoleFilter = (translate, isMobile) => (
    <SelectInput
        source='role'
        label={translate('resources.user.filters.role')}
        choices={getServiceRoleChoices(translate)}
        emptyText={translate('common.all')}
        alwaysOn={isMobile}
    />
);
const contractorFilter = (translate, isMobile) => (
    <ReferenceArrayFilter
        source='contractorIds_like'
        reference='contractor'
        label={translate('resources.user.filters.contractor')}
        forceDesktopOnMobile={true}
        alwaysOn={isMobile}
    />
);
const serviceCompanyFilter = (translate, isMobile) => (
    <ReferenceArrayFilter
        source='serviceCompanyId_in'
        reference='service-company'
        label={translate('resources.user.filters.serviceCompany')}
        forceDesktopOnMobile={true}
        alwaysOn={isMobile}
    />
);

export const getUserFilters = ({ isAdminOrBok, isClientMaster, isServiceMaster, translate, isMobile }) => {
    if (isAdminOrBok) {
        return [adminSearchBar(translate), roleFilter(translate, isMobile), contractorFilter(translate, isMobile), serviceCompanyFilter(translate, isMobile)];
    }
    if (isClientMaster) {
        return [masterSearchBar(translate), clientMasterRoleFilter(translate, isMobile)];
    }
    if (isServiceMaster) {
        return [masterSearchBar(translate), serviceMasterRoleFilter(translate, isMobile)];
    }
    return [];
};
